"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'table.controls.export': 'Exportar',
    'table.controls.columns': 'Columnas',
};
